import {useSelector} from 'react-redux'
import './index.scss'
import classNames from 'classnames'
import Tooltip from '../tooltip'
import {HelpIcon} from '../../../icons'
import {useRef} from 'react'
import {colors} from '../../../utils/colors'

const MOBILE_WIDTH = 576
const Checkbox = ({name, value, id, label, className, type, onChange, checked, disabled = false, hasValue, readOnly = false, infoText}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const checkBoxRef = useRef(null)

    return (
        <div
            className={classNames('checkbox', {
                disabled: disabled,
                [className]: !!className
            })} ref={checkBoxRef}>
            <label className={classNames('checkbox-label', {
                'dark': isDarkMode
            })}>
                {label}
                <input disabled={disabled} value={value} onChange={onChange}
                    className="checkbox-input"
                    type={type} name={name}
                    id={id}
                    checked={checked}
                    readOnly={readOnly}
                />
                <span className={classNames('checkbox-span', {
                    'dark': isDarkMode
                })}>{hasValue && value}</span>
            </label>
            {infoText && (
                <Tooltip placement={window?.innerWidth <= MOBILE_WIDTH ? 'left' : 'right'} trigger="click" content={infoText} appendTo={checkBoxRef?.current}>
                    <HelpIcon stroke={colors.colorBgFilter} width="22" height="22" />
                </Tooltip>
            )}
        </div>
    )
}

export default Checkbox
